<script>
import Usp from './usp.vue';

export default {
  components: {
    Usp
  },

  props: {
    productImageUrl: {
      type: String,
      required: false,
      default: null
    },

    companyImageUrl: {
      type: String,
      required: false,
      default: null
    },

    showDescription: {
      type: Boolean,
      required: false,
      default: false
    },

    description: {
      type: String,
      required: false,
      default: null
    },

    title: {
      type: String,
      required: true
    },

    usps: {
      type: Array,
      required: false,
      default: () => []
    }
  }
};
</script>

<template>
  <div class="row px-4 px-md-0">
    <div class="col-md-12 d-flex order-2 order-md-1 mt-5 mt-md-0">
      <div class="row align-items-center">
        <div
          v-if="companyImageUrl"
          class="col-12 col-sm-auto c-company-logo pb-2 pb-sm-0"
        >
          <img :src="companyImageUrl">
        </div>

        <div class="col-12 col-sm-auto c-product-name">
          {{ title }}
        </div>
      </div>
    </div>

    <div class="col-md-6 order-3 order-md-2">
      <div
        v-if="showDescription && description"
        class="col-12 col-sm-auto m-0 mt-5 c-product-description"
      >
        {{ description }}
      </div>
      <div class="col-12 col-sm-auto">
        <ul
          v-if="usps.length"
          class="c-usps m-0 mt-5"
        >
          <usp
            v-for="(usp, index) in usps"
            :key="index"
            :usp="usp"
          />
        </ul>
      </div>
    </div>

    <div class="col-md-6 align-self-center order-1 order-md-3 d-none d-sm-block m-o mt-5">
      <div
        v-if="productImageUrl"
        class="c-product-logo d-flex align-items-center justify-content-center"
      >
        <img :src="productImageUrl">
      </div>
    </div>
  </div>
</template>
